import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
export default Input;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/input/index.js
// module id = 129
// module chunks = 0